module.exports = __webpack_public_path__ + "static/media/wizard-create.6036b172.svg";